<h1>Home</h1>

<jb-btn (jbClick)="router.navigate(['games/'])" jbType="update" jbText="view.common.go"></jb-btn>
